"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var create_1 = require(36);
function emit(fn) {
    return create_1.create({
        didSubscribe: function () {
            var _this = this;
            var cb = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _this.set.apply(_this, args);
            };
            this._cancel = fn(cb, this.props, this.providers);
        },
        willDestroy: function () {
            if (typeof this._cancel === 'function') {
                this._cancel(this.props);
            }
        }
    });
}
exports.emit = emit;
//# sourceMappingURL=emit.js.map